import React from 'react';
import { Grid } from '@mui/material';
import { useParams, Navigate } from 'react-router-dom';
import ProductDetail from '../student/Products/ProductDetail';
import TournamentDetail from '../student/Tournament/TournamentDetail';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { isParent, isStudent } from '@projectK/context/RolesProvider';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import PropTypes from 'prop-types';

const ProductWizardPage = ({ isProduct }) => {
  const { productSlug, tournamentSlug } = useParams();
  const { user } = useAuthUser();
  const { isMobile } = useMobileSettings();

  // Logged-in students/parents use in-app routes, not public widget URLs.
  if (user?.id && (isStudent(user) || isParent(user))) {
    if (productSlug) {
      return <Navigate to={`/product-details/${productSlug}`} replace />;
    }
    if (tournamentSlug) {
      const homePath = isMobile
        ? `/${user.roleMenuFlag[0]}/events`
        : '/dashboard';
      return <Navigate to={homePath} replace />;
    }
  }

  // If user is logged in and we're in widget mode, redirect to product details page
  if (productSlug && user?.id) {
    return <Navigate to={`/product-details/${productSlug}`} replace />;
  }

  return (
    <Grid
      sx={{
        p: 5,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
      }}
      className='item-hover'
    >
      {isProduct ? (
        <ProductDetail slug={productSlug} />
      ) : (
        <TournamentDetail slug={tournamentSlug} />
      )}
    </Grid>
  );
};

ProductWizardPage.propTypes = {
  isProduct: PropTypes.bool,
};
export default ProductWizardPage;
